import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  DEFAULT_USER_DETAILS,
  assessmentQuestionsAndGabitMap,
} from "./constants";
import makeRequest from "../../../api";
import {
  getAllAssessmentQuestionsList,
  getUserNutritionAssessmentResponseList,
} from "../../../api/services/assessment";
import { subscriptionService, userService } from "../../../api/services";
import { toast } from "react-toastify";

const GABIT = "FITNESS";

const Assessment = () => {
  const params = useParams();

  const userId = params.userId || undefined;

  const [responseList, setResponseList] = useState<Array<any>>([]);
  const [allQuestionsMap, setAllQuestionsMap] = useState<any>({});
  const [userDetails, setUserDetails] = useState(DEFAULT_USER_DETAILS);

  const userGabit = userDetails?.gabit || undefined;
  const userHealthGoal = userDetails?.healthGoal || undefined;

  let responseListMap: any = {};
  responseList?.forEach((item: any) => {
    responseListMap = {
      ...responseListMap,
      [item?.questionCode]: item,
    };
  });

  useEffect(() => {
    getCurrentPlanData();
    getAllQuestions();
    (async () => {
      try {
        const res = await makeRequest(userService.getUserDetails(userId));
        setUserDetails((prev) => ({
          ...prev,
          name: res?.data?.userDto?.fullName,
        }));
      } catch (error: any) {
        toast.error("Error fetching user details!");
      }
    })();
  }, []);

  useEffect(() => {
    if (!!userGabit && !!userHealthGoal && !!userId) {
      fetchAssessmentResponse();
    }
  }, [userGabit, userHealthGoal]);

  const fetchAssessmentResponse = async () => {
    try {
      const res = await makeRequest(
        getUserNutritionAssessmentResponseList(
          {
            healthGoal: userHealthGoal,
            gabit: userGabit,
          },
          userId
        )
      );
      setResponseList([...res?.data?.responseList]);
    } catch (error: any) {
      toast.error("Error fetching user's assessment response!");
    }
  };

  const getCurrentPlanData = async () => {
    try {
      const res = await makeRequest(
        subscriptionService.getUserCurrentActive(userId)
      );

      const plan =
        res?.data?.data?.find(
          (item: { [key: string]: any }) => item.gabit === GABIT
        ) || {};

      setUserDetails((prev) => ({
        ...prev,
        gabit: plan?.gabit,
        healthGoal: plan?.healthGoal,
      }));
    } catch (error: any) {
      toast.error("Error fetching user's current active plans");
    }
  };

  const getAllQuestions = async () => {
    try {
      const res = await makeRequest(getAllAssessmentQuestionsList());

      let questionsMap = {};
      res?.data?.forEach((item: any) => {
        questionsMap = {
          ...questionsMap,
          [item?.questionCode]: item,
        };
      });

      setAllQuestionsMap({ ...questionsMap });
    } catch (error: any) {
      toast.error("Error fetching all assessment questions!");
    }
  };

  const render = (key: any, key2: any) => {
    switch (allQuestionsMap?.[key]?.renderType) {
      case "what-kind-workout":
        return (
          <p className="mb-0 ps-4">
            {allQuestionsMap?.[key2]?.options
              ?.filter((item: any) => {
                const option = JSON.parse(item);
                return responseListMap?.[key]?.response
                  ?.split(",")
                  ?.some((item: any) => item === option?.optionKey);
              })
              ?.map((item: any) => JSON.parse(item)?.title)
              ?.join(", ")}
          </p>
        );
      case "what-device":
        return (
          <p className="mb-0 ps-4">
            {allQuestionsMap?.[key2]?.options
              ?.filter((item: any) => {
                const option = JSON.parse(item);
                return responseListMap?.[key]?.response
                  ?.split(",")
                  ?.some((item: any) => item === option?.optionKey);
              })
              ?.map((item: any) => JSON.parse(item)?.title)
              ?.join(", ")}
          </p>
        );
      case "how-often":
        return (
          <p className="mb-0 ps-4">
            {allQuestionsMap?.[key2]?.options
              ?.filter((item: any) => {
                const option = JSON.parse(item);
                return responseListMap?.[key]?.response
                  ?.split(",")
                  ?.some((item: any) => item === option?.optionKey);
              })
              ?.map((item: any) => JSON.parse(item)?.title)
              ?.join(", ")}
          </p>
        );
      case "horizontal-slider-4":
        return (
          <p className="mb-0 ps-4">
            {allQuestionsMap?.[key2]?.options
              ?.filter((item: any) => {
                const option = JSON.parse(item);
                return responseListMap?.[key]?.response?.includes(
                  option?.optionKey
                );
              })
              ?.map((item: any) => {
                const parsedItem = JSON.parse(item);
                const parsedKey = JSON.parse(responseListMap[key]?.response)
                  ?.timeSlot?.key;

                return `${parsedItem?.title} - ${
                  parsedItem?.timeSlots?.find(
                    (item: any) => item?.key === parsedKey
                  )?.pillLabel
                }`;
              })}
          </p>
        );
      default:
        return <p className="mb-0 ps-4">{responseListMap?.[key]?.response}</p>;
    }
  };

  return (
    <div className="container-lg">
      <h6 className="fw-700 fs-24 mb-3">
        {userDetails?.name || "User"} Assessment Responses
      </h6>
      {Object.keys(assessmentQuestionsAndGabitMap)?.map((item: any) => {
        const key = item as keyof typeof responseListMap;
        const key2 = item as keyof typeof allQuestionsMap;

        if (!responseListMap?.[key]) {
          return null;
        }

        return (
          <div
            className="form-group mb-3"
            key={responseListMap?.[key]?.questionCode}
          >
            <label className="mb-2 fw-600">
              Q - {allQuestionsMap?.[key]?.title}
            </label>
            {render(key, key2)}
          </div>
        );
      })}
    </div>
  );
};

export default Assessment;
